import smsService from "../../api/reservePlan.service";
import { mapGetters } from "vuex";
import utils from "../../utils/util";
import pageheader from "../pageheader";
import rules from "../../utils/rules";
export default {
  name: "sms-alerts",
  components: { pageheader },
  props: [],
  data() {
    return {
      list: [],
      day: [],
      isAlertsLoading: false,
      rules: rules,
      reportsresponse: [],
      input: {},

      headers: [
        { text: "Last Delivered", value: "DeliveryDateReceipt", width: "12%" },
        { text: "Report Name", value: "ReportName", width: "30%" },
        { text: "Date Range", value: "DateRange" },
        { text: "Text Column Filter", value: "FilterString" },
        { text: "Number or Date Column Filter", value: "FilterNonString" },
        { text: "Delivery", value: "Delivery" },
        { text: "Day of Week", value: "Days" },

        { text: "Actions", value: "actions" },
      ],
      loadingSave:false,
      loadingupdate:false,
      //
      ReportName: [],
      DateRange: [
        { name: "Past 60 Days", value: "Past 60 Days" },
        { name: "Year to Date", value: "Year to Date" },
        { name: "None", value: "None" },
      ],
      FilterStringColumn: [
        // {name: 'Picked Up By', value: 'PickedUpBy'},{name: 'Ordered By', value: 'OrderedBy'}
      ],
      FilterStringOperand: [
        { name: "<Operand>", value: "" },
        { name: "=", value: "=" },
        { name: "<>", value: "<>" },
        { name: "Like", value: "Like" },
        { name: "Not Like", value: "Not Like" },
      ],
      FilterNonStringColumn: [
        // {name: 'Date Out'},{name: 'Days On Rent'},{name: 'QTY'},{name: 'Price'}
      ],
      FilterNonStringOperand: [
        { name: "<Operand>", value: "" },
        { name: "<>", value: "<>" },
        { name: "<", value: "<" },
        { name: "<=", value: "<=" },
        { name: "=", value: "=" },
        { name: ">=", value: ">=" },
        { name: ">", value: ">" },
        { name: "= Current", value: "= Current" },
      ],
      Delivery: [
        { name: "Weekly", value: "Weekly on:" },
        { name: "Monthly", value: "Monthly on:" },
      ],
      infoDialog: false,
      _daysMap: {},
      _columns: {},
      Days: [],
      BirchEmailAlertIDEdit:"",
      edit: false,
      delivery: "",
      report: "",
      search: "",
      dateRangee: "",
      column1: "",
      column2: "",
      valid: true,
      StringOperand: "",
      NonStringOperand: "",
      FilterStringValue: "",
      FilterNonStringValue: "",
      newAlertField: {},
      _selectedAlert: {
        BirchEmailAlertID: "",
        LastDelivered: "",
        ReportName: "",
        DateRange: "",
        FilterString: "",
        FilterNonString: "",
        Delivery: "",
        Days: "",
      },

      REPORT_ALERT_OPTIONS: {
        ACTIVEMAINTENANCE: {
          StringColumns: [
            "CNTR",
            "ContractType",
            "RepairType",
            "Status",
            "ItemKey",
            "ItemName",
            "ContractInfo",
            "Jobsite",
            "TransactionType",
          ],
          NonStringColumns: [
            "Qty",
            "Horsepower",
            "DateOut",
            "Parts",
            "Labor",
            "Total",
          ],
        },
        ACTUALCOSTTODATE: {
          StringColumns: [
            "CNTR",
            "Status",
            "ItemKey",
            "ItemName",
            "Jobsite",
            "JobNo",
            "PONo",
            "OrderedBy",
            "PickedUpBy",
            "TransactionType",
          ],
          NonStringColumns: [
            "QTY",
            "Price",
            "DateOut",
            "DueDate",
            "DateBilled",
            "DaysOnRent",
          ],
        },
        CUSTOMERBALANCE: {
          StringColumns: [
            "NAME",
            "CNTR",
            "Status",
            "C_Status",
            "Restrictions",
            "STR",
            "Jobsite",
            "JobNo",
            "PONo",
            "OrderedBy",
            "PickedUpBy",
            "TransactionType",
          ],
          NonStringColumns: [
            "Opened",
            "Closed",
            "TOTAL",
            "PAID",
            "< 31",
            "31 - 60",
            "61 - 90",
            "> 90",
          ],
        },
        HISTORICALMAINTENANCE: {
          StringColumns: [
            "CNTR",
            "RepairType",
            "Status",
            "ItemKey",
            "ItemName",
            "ContractInfo",
            "Jobsite",
            "TransactionType",
          ],
          NonStringColumns: [
            "Qty",
            "Horsepower",
            "DateOut",
            "DateIn",
            "Parts",
            "Labor",
            "Total",
          ],
        },
        OFFRENT: {
          StringColumns: [
            "CNTR",
            "ItemKey",
            "ItemName",
            "Status",
            "Jobsite",
            "JobNo",
            "PONo",
            "ContractInfo",
            "OrderedBy",
            "PickedUpBy",
            "TransactionType",
          ],
          NonStringColumns: [
            "Horsepower",
            "QTY",
            "DateOut",
            "DueDate",
            "DaysOffRent",
            "DaysOnRent",
          ],
        },
        ONRENT: {
          StringColumns: [
            "ContractStatus",
            "CNTR",
            "ItemKey",
            "ItemName",
            "ItemStatus",
            "Jobsite",
            "JobNo",
            "PONo",
            "ContractInfo",
            "OrderedBy",
            "PickedUpBy",
            "TransactionType",
          ],
          NonStringColumns: [
            "Qty",
            "Horsepower",
            "DateOut",
            "DueDate",
            "DaysOut",
          ],
        },
        ONRENTWITHCOSTANALYSIS: {
          StringColumns: [
            "CNTR",
            "Status",
            "ItemKey",
            "ItemName",
            "ItemStatus",
            "Jobsite",
            "JobNo",
            "PONo",
            "ContractInfo",
            "OrderedBy",
            "PickedUpBy",
            "TransactionType",
          ],
          NonStringColumns: [
            "Horsepower",
            "Qty",
            "DateOut",
            "DueDate",
            "DaysOnRent",
            "DailyAmount",
            "WeeklyAmount",
            "MonthlyAmount",
            "CostToDate",
            "EstTotalCost",
            "OldEstTotalCost",
          ],
        },
        RENTTODATEANDPROJECTED: {
          StringColumns: [
            "CNTR",
            "ItemKey",
            "ItemName",
            "ItemStatus",
            "ContractStatus",
            "Jobsite",
            "JobNo",
            "PONo",
            "ContractInfo",
            "OrderedBy",
            "PickedUpBy",
            "BilledTo",
            "TransactionType",
          ],
          NonStringColumns: [
            "Horsepower",
            "Qty",
            "DailyAmount",
            "WeeklyAmount",
            "MonthlyAmount",
            "BilledCost",
            "ProjectedCost",
            "DateOut",
            "DateIn",
            "DaysOnRent",
            "Billed",
          ],
        },
        ITEMSRENTED: {
          StringColumns: [
            "CNTR",
            "ItemKey",
            "ItemName",
            "ItemStatus",
            "ContractStatus",
            "Jobsite",
            "JobNo",
            "PONo",
            "ContractInfo",
            "OrderedBy",
            "PickedUpBy",
            "BilledTo",
            "TransactionType",
          ],
          NonStringColumns: [
            "Horsepower",
            "Qty",
            "DailyAmount",
            "WeeklyAmount",
            "MonthlyAmount",
            "BilledCost",
            "ProjectedCost",
            "DateOut",
            "DateIn",
            "DaysOnRent",
            "Billed",
          ],
        },
        RESERVATION: {
          StringColumns: [
            "Status",
            "CNTR",
            "shortCNTR",
            "ItemStatus",
            "ItemKey",
            "ItemName",
            "Jobsite",
            "JobNo",
            "PONo",
            "ContractInfo",
            "OrderedBy",
            "PickedUpBy",
            "TransactionType",
          ],
          NonStringColumns: [
            "DateOut",
            "LatestDateOut",
            "Qty",
            "Horsepower",
            "DueDate",
            "Days",
          ],
        },
        SERVICECALL: {
          StringColumns: [
            "CNTR",
            "Str",
            "ItemKey",
            "ItemName",
            "Status",
            "JobSite",
            "PONo",
            "JobNo",
            "ContractInfo",
            "TransactionType",
            "TransactionOperation",
          ],
          NonStringColumns: ["OpenedDate", "ClosedDate", "Comment"],
        },
      },
    };
  },
  created() {
    (this._columns = {
      ACTIVEMAINTENANCE: undefined,
      ACTUALCOSTTODATE: undefined,
      CUSTOMERBALANCE: undefined,
      HISTORICALMAINTENANCE: undefined,
      OFFRENT: undefined,
      ONRENT: undefined,
      ONRENTWITHCOSTANALYSIS: undefined,
      RENTTODATEANDPROJECTED: undefined,
      ITEMSRENTED: undefined,
      RESERVATION: undefined,
      SERVICECALL: undefined,
    }),
      (this._daysMap = {
        DeliveryMon: "Monday",
        DeliveryTue: "Tuesday",
        DeliveryWed: "Wednesday",
        DeliveryThu: "Thursday",
        DeliveryFri: "Friday",
        DeliverySat: "Saturday",
        DeliverySun: "Sunday",
      }),
      //

      (this.Days = [
        { name: this._daysMap.DeliveryMon, value: this._daysMap.DeliveryMon },
        { name: this._daysMap.DeliveryTue, value: this._daysMap.DeliveryTue },
        { name: this._daysMap.DeliveryWed, value: this._daysMap.DeliveryWed },
        { name: this._daysMap.DeliveryThu, value: this._daysMap.DeliveryThu },
        { name: this._daysMap.DeliveryFri, value: this._daysMap.DeliveryFri },
        { name: this._daysMap.DeliverySat, value: this._daysMap.DeliverySat },
        { name: this._daysMap.DeliverySun, value: this._daysMap.DeliverySun },
      ]),
      console.log(this.Days + "Days");
    this.newAlertField = {
      ReportName: [],
      DateRange: [
        { name: "Past 60 Days", value: "Past 60 Days" },
        { name: "Year to Date", value: "Year to Date" },
        { name: "None", value: "None" },
      ],
      FilterStringColumn: [
        // {name: 'Picked Up By', value: 'PickedUpBy'},{name: 'Ordered By', value: 'OrderedBy'}
      ],
      FilterStringOperand: [
        { name: "<Operand>", value: "" },
        { name: "=", value: "=" },
        { name: "<>", value: "<>" },
        { name: "Like", value: "Like" },
        { name: "Not Like", value: "Not Like" },
      ],
      FilterNonStringColumn: [
        // {name: 'Date Out'},{name: 'Days On Rent'},{name: 'QTY'},{name: 'Price'}
      ],
      FilterNonStringOperand: [
        { name: "<Operand>", value: "" },
        { name: "<>", value: "<>" },
        { name: "<", value: "<" },
        { name: "<=", value: "<=" },
        { name: "=", value: "=" },
        { name: ">=", value: ">=" },
        { name: ">", value: ">" },
        { name: "= Current", value: "= Current" },
      ],
      Delivery: [
        { name: "Weekly", value: "Weekly on:" },
        { name: "Monthly", value: "Monthly on:" },
      ],
      Days: [
        { name: this._daysMap.DeliveryMon, value: this._daysMap.DeliveryMon },
        { name: this._daysMap.DeliveryTue, value: this._daysMap.DeliveryTue },
        { name: this._daysMap.DeliveryWed, value: this._daysMap.DeliveryWed },
        { name: this._daysMap.DeliveryThu, value: this._daysMap.DeliveryThu },
        { name: this._daysMap.DeliveryFri, value: this._daysMap.DeliveryFri },
        { name: this._daysMap.DeliverySat, value: this._daysMap.DeliverySat },
        { name: this._daysMap.DeliverySun, value: this._daysMap.DeliverySun },
      ],
    };
  },
  computed: {
    ...mapGetters(["roles","smsUserId"]),
  },
  mounted() {
    this.input = utils.getInputContent("smsalert", this.roles);

    this.getEmailReportsList();
    this.getEmailAlertsList();
  },
  methods: {
    async getEmailAlertsList() {
      try {
        this.isAlertsLoading = true;
        let response = await smsService.getEmailAlertsList(this.smsUserId);
        if (response) {
          console.log(response);
          this.list = response;
          this.list.sort((a, b) => {
            return a["ReportName"] < b["ReportName"]
              ? -1
              : a["ReportName"] === b["ReportName"]
              ? 0
              : 1;
          });
          this.isAlertsLoading = false;

          //   this.list = this.list.map((d, index) => ({
          //   ...d
          // }));
        }
      } catch (err) {
        this.isAlertsLoading = false;

        console.log(err);
      }
    },
    async getEmailReportsList() {
      try {
        const reportName = [];
        let response = await smsService.getEmailReportsList();
        if (response) {
          console.log(response);
          this.reportsresponse = response;
          response.forEach((report) => {
            const id = report["ReportName"]
              .replace(/ /g, "")
              .replace(/&/g, "AND")
              .toUpperCase();
            //

            this._columns[id] = report["Columns"];
            console.log(id);
            console.log("col" + this._columns);
            console.log("colsss" + report["Columns"]);
            // rptId 43 is rptName PlannedVsActual
            // if (+report['BirchReportID']!==43 && !this._reportRestrictions.find(rId => { return +report['BirchReportID'] == rId})) {
            //
            reportName.push(report);
            // }
          });
          reportName.sort((a, b) => {
            return a.ReportName < b.ReportName
              ? -1
              : a.ReportName === b.ReportName
              ? 0
              : 1;
          });
          this.newAlertField.ReportName = reportName;
        }
      } catch (err) {
        console.log(err);
      }
    },
    editAlert(row) {
      console.log(row);
      this.report = row.ReportName;
     
      this.editedcol(row);
      // this._selectedAlert = this._alerts.find((alert) => {
      //   return alert["BirchEmailAlertID"] === row["BirchEmailAlertID"];
      // });
      // this._displaySelected();
    },
    editedcol(row) {
      this.updateColumns();

      this.dateRangee = row.DateRange;
      this.column1 = row.FilterStringColumn;
      this.StringOperand = row.FilterStringOperand;
      this.FilterStringValue = row.FilterStringValue;
      this.column2 = row.FilterNonStringColumn;
      this.NonStringOperand = row.FilterNonStringOperand;
      this.FilterNonStringValue = row.FilterNonStringValue;
      this.delivery = row.Delivery;
this.BirchEmailAlertIDEdit = row.BirchEmailAlertID;
      if (row.DeliveryMon) {
        this.day.push("Monday");
      }
      if (row.DeliveryTue) {
        this.day.push("Tuesday");
      }
      if (row.DeliveryWed) {
        this.day.push("Wednesday");
      }
      if (row.DeliveryThu) {
        this.day.push("Thursday");
      }
      if (row.DeliveryFri) {
        this.day.push("Friday");
      }
      if (row.DeliverySat) {
        this.day.push("Saturday");
      }
      if (row.DeliverySun) {
        this.day.push("Sunday");
      }
    },
    updateColumns() {
      //

      let id = this.report.replace(/ /g, "").replace(/&/g, "AND").toUpperCase();

      this.newAlertField.FilterStringColumn = this.REPORT_ALERT_OPTIONS[id][
        "StringColumns"
      ].map((col) => {
        return { name: col, value: col };
      });

      this.newAlertField.FilterNonStringColumn = this._columns[id]
        ? this._columns[id]
            .map((col) => {
              return { name: col["ColumnName"], value: col["Value"] };
            })
            .filter((col) => {
              return this.REPORT_ALERT_OPTIONS[id]["NonStringColumns"].some(
                (c) => {
                  return c === col.name;
                }
              );
            })
        : (this.newAlertField.FilterNonStringColumn = []);

      this.newAlertField.FilterStringColumn.unshift({
        name: "<Column>",
        value: "",
      });
      this.newAlertField.FilterNonStringColumn.unshift({
        name: "<Column>",
        value: "",
      });
      this.cleardata();
    },
    cleardata() {
      this.dateRangee = "";
      this.column1 = "";
      this.StringOperand = "";
      this.FilterStringValue = "";
      this.column2 = "";
      this.NonStringOperand = "";
      this.FilterNonStringValue = "";
      this.delivery = "";
      this.day = [];
    },
    async postEmailAlertsList() {
      //

      let temp = this.reportsresponse.filter(
        (e) => e.ReportName == this.report
      );
      let temp2 = this.Days;
      console.log(this.Days + "Days");
      console.log(temp2);
      let payload = {
        BirchReportID: temp[0].BirchReportID,
        ReportName: this.report,
        DateRange: this.dateRangee,
        FilterStringColumn: this.column1,
        FilterStringOperand: this.StringOperand,
        FilterStringValue: this.FilterStringValue,
        FilterNonStringColumn: this.column2,
        FilterNonStringOperand: this.NonStringOperand,
        FilterNonStringValue: this.FilterNonStringValue,
        Delivery: this.delivery,
        DeliveryMon: this.day.includes("Monday") ? true : false,
        DeliveryTue: this.day.includes("Tuesday") ? true : false,
        DeliveryWed: this.day.includes("Wednesday") ? true : false,
        DeliveryThu: this.day.includes("Thursday") ? true : false,
        DeliveryFri: this.day.includes("Friday") ? true : false,
        DeliverySat: this.day.includes("Saturday") ? true : false,
        DeliverySun: this.day.includes("Sunday") ? true : false,
      };
      try {
        this.loadingSave = true;
        let response = await smsService.postEmailAlertsList(this.smsUserId,payload);
        if (response) {
          console.log("sug" + response);
          this.cleardata();
          this.loadingSave = false;
          this.infoDialog =false;
          this.getEmailAlertsList();
        }
      } catch (err) {
        console.log(err);
        this.loadingSave = false;

      }
      console.log(payload);
    },
    async putEmailAlertsList() {
      let temp = this.reportsresponse.filter(
        (e) => e.ReportName == this.report
      );
      console.log(this.reportsresponse);
      let temp2 = this.Days;
      console.log(this.Days + "Days");
      console.log(temp2);
      let payload = {
        BirchReportID: temp[0].BirchReportID,
        ReportName: this.report,
        DateRange: this.dateRangee,
        FilterStringColumn: this.column1,
        FilterStringOperand: this.StringOperand,
        FilterStringValue: this.FilterStringValue,
        FilterNonStringColumn: this.column2,
        FilterNonStringOperand: this.NonStringOperand,
        FilterNonStringValue: this.FilterNonStringValue,
        Delivery: this.delivery,
        DeliveryMon: this.day.includes("Monday") ? true : false,
        DeliveryTue: this.day.includes("Tuesday") ? true : false,
        DeliveryWed: this.day.includes("Wednesday") ? true : false,
        DeliveryThu: this.day.includes("Thursday") ? true : false,
        DeliveryFri: this.day.includes("Friday") ? true : false,
        DeliverySat: this.day.includes("Saturday") ? true : false,
        DeliverySun: this.day.includes("Sunday") ? true : false,
      };
      try {
        this.loadingupdate = true;
        let response = await smsService.putEmailAlertsList(this.smsUserId,payload, String(this.BirchEmailAlertIDEdit));
        if (response) {
          console.log("sug" + response);
          this.cleardata();
        this.loadingupdate = false;

this.infoDialog =false;
          this.getEmailAlertsList();
        }
      } catch (err) {
        console.log(err);
        this.loadingupdate = false;

      }
      console.log(payload);
    },
    async deleteAlert(item) {
      let id = String(item.BirchEmailAlertID);
      try {
        let response = await smsService.deleteAlert(this.smsUserId,id);
        if (response) {
          console.log("sug" + response);
          this.getEmailAlertsList();
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
